export default ({ styles }) => `
<div class="${styles.scrim}"></div>
`;
